// i18n (2026-10-06, Brazil pilots): detects the browser language, remembers an
// explicit choice in localStorage ("ui_language"), falls back to English.
// Strings live in ./locales/*.json — the PI can replace pt-BR.json wholesale.
import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import en from "./locales/en.json";
import ptBR from "./locales/pt-BR.json";

i18n
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
        resources: { en: { translation: en }, "pt-BR": { translation: ptBR }, pt: { translation: ptBR } },
        fallbackLng: "en",
        supportedLngs: ["en", "pt-BR", "pt"],
        nonExplicitSupportedLngs: true,
        detection: { order: ["localStorage", "navigator"], lookupLocalStorage: "ui_language", caches: ["localStorage"] },
        interpolation: { escapeValue: false },
    });

export default i18n;
